/// <amd-module name="Artifacts/Root/components/CenteredSpinner" />
import * as React from "react";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

interface ICenteredSpinnerProps {
  label?: string;
}

const CenteredSpinner: React.FC<ICenteredSpinnerProps> = ({ label }) => (
  <Spinner size={SpinnerSize.large} className="centered-spinner" label={label} />
);

export { CenteredSpinner };
